import { OgTag } from 'common/types/ogTag'
import {
  getVertical,
  getVerticalBySubVertical,
  getVerticalFullName,
  getVerticalName,
  SubVertical,
  subVerticalConfig,
  Vertical,
  verticalOgTag,
} from 'common/constants'
import { SSChannel } from 'common/types/entities/api/channel'
import { Content } from 'common/types/entities/mongo/content'
import { THUMB_TYPE } from '@shopping/Img'

export const makeStoreOgTag = (channel: SSChannel): OgTag => {
  if (!channel) {
    return {
      title: null,
      imageUrl: null,
    }
  }
  const vertical = subVerticalConfig[channel.windowSubVertical].vertical
  const channelName =
    vertical !== Vertical.DESIGNER
      ? channel.channelName
      : channel.additionalAttribute.channelAlias || channel.channelName
  const logoImage = channel.logoImage

  return {
    title: vertical ? `${channelName} : 네이버쇼핑 ${getVerticalName(vertical)}` : `${channelName} : 네이버쇼핑`,
    imageUrl: logoImage && channel.logoImage.imageUrl ? channel.logoImage.imageUrl : verticalOgTag[vertical].imageUrl,
    description: channel.description || null,
  }
}

export const makeStoreArticleDetailOgTag = (channel: SSChannel, content: Content): OgTag => {
  const vertical = subVerticalConfig[channel.windowSubVertical].vertical

  if (!channel || !content) {
    return {
      title: null,
      imageUrl: null,
    }
  }

  const repImage =
    content.se3ContentsImageInfo && content.se3ContentsImageInfo.length > 0
      ? content.se3ContentsImageInfo.find(image => image.representativeImage === true)
      : content.userImageInfos && content.userImageInfos.length > 0 && content.userImageInfos[0]

  return {
    title: content.title,
    imageUrl: repImage ? repImage.imageUrl : verticalOgTag[vertical].imageUrl,
    description: channel.channelName,
  }
}

export const setOgTagMeta = (setMeta, ogTag: OgTag) => {
  setMeta('property', 'og:title', ogTag.title)
  setMeta('property', 'og:image', convertThumbnail(ogTag.imageUrl, THUMB_TYPE.M450))

  if (ogTag.description) {
    setMeta('property', 'og:description', ogTag.description)
  }
}

export const convertThumbnail = (imageUrl: string, thumbType: THUMB_TYPE) => {
  if (
    imageUrl &&
    (imageUrl.startsWith('https://shop-phinf.pstatic.net/') ||
      imageUrl.startsWith('http://beta.bshop.phinf.naver.net/'))
  ) {
    return `${imageUrl.split(/[?#]/)[0]}?type=${thumbType}`
  }
  return imageUrl
}

export const makeDefaultOgTag = (verticalType: Vertical | SubVertical): OgTag => {
  if (!verticalType) {
    return {
      title: null,
      imageUrl: null,
    }
  }

  const vertical = getVertical(verticalType.toLowerCase()) || getVerticalBySubVertical(verticalType.toLowerCase())

  return {
    title: `네이버쇼핑 ${getVerticalFullName(vertical)}`,
    imageUrl: verticalOgTag[vertical].imageUrl,
    description: verticalOgTag[vertical].description,
  }
}
